<div class="body">
  <div class="login">
    <mat-spinner class="spinner" *ngIf="loading"></mat-spinner>
    <button
        (click)="loginWithGoogle()"
        class="ancho"
        mat-raised-button
        mat-button
        color="primary"
      >
        Entrar com o google
      </button>
  </div>
</div>
